import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { AccountKeysListComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account/account-keys-list/account-keys-list.component';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
const ManageAccount = ({ setTitleContainerProperties, activeAccount, localAccounts, }) => {
    const [wrongKeysFound, setWrongKeysFound] = useState();
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_manage_accounts',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        if (activeAccount) {
            const selectedLocalAccount = localAccounts.find((localAccount) => localAccount.name === activeAccount.name);
            let tempFoundWrongKeys;
            tempFoundWrongKeys = { [activeAccount.name]: [] };
            for (const [key, value] of Object.entries(selectedLocalAccount.keys)) {
                tempFoundWrongKeys = KeysUtils.checkWrongKeyOnAccount(key, value, activeAccount.name, activeAccount.account, tempFoundWrongKeys);
            }
            if (tempFoundWrongKeys[activeAccount.name].length > 0) {
                setWrongKeysFound(tempFoundWrongKeys);
            }
            else {
                setWrongKeysFound(undefined);
            }
        }
    }, [activeAccount]);
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_MANAGE_ACCOUNTS}-page`, className: "settings-manage-account" },
        React.createElement(SelectAccountSectionComponent, { background: "white", fullSize: true }),
        React.createElement(AccountKeysListComponent, { wrongKeysFound: wrongKeysFound })));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        localAccounts: state.steem.accounts,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
});
export const ManageAccountComponent = connector(ManageAccount);
